import React, { useState, useEffect } from 'react';
import style from '../css/Plans.module.css';
// import '../Header/Header.css';

import { IoCheckmark } from 'react-icons/io5';
import { BsArrowRight } from 'react-icons/bs';
import { AiFillQuestionCircle } from 'react-icons/ai';

import { getRemainingTimeUntilMsTimestamp } from '../utils/countdown';
import ReactPlayer from 'react-player';

import { plans1 } from '../utils/plans';
// import SupportInitiative from '../SupportInitiative/SupportInitiative';
import SimpleModal from './modals/SimpleModal';
import SimpleModal2 from './modals/SimpleModal2';

// import presencial from '../../assets/presencial.jpeg';
// import enLinea from '../../assets/en-linea.jpeg';

import lineLeft from '../images/info-line-left.svg';
import lineRight from '../images/info-line-right.svg';
import lineBot from '../images/line-bot.png';
import lineTop from '../images/line-top.png';

function Plans() {
	//simple modal
	const [close, setClose] = useState(true);
	const [close2, setClose2] = useState(true);
	const [url, setUrl] = useState('');

	const handlerClose = (url) => {
		setUrl(url);
		close ? setClose(false) : setClose(true);
	};

	const handlerClose2 = () => {
		close2 ? setClose2(false) : setClose2(true);
	};

	const handleCloseModal = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	const handleCloseModal2 = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	const [changePlan, setChangePlan] = useState(plans1);
	const [modal, setModal] = useState(false);
	const [more, setMore] = useState('');

	const closeModal = () => setModal(false);

	const openModal = (more) => {
		setModal(true);
		setMore(more);
	};

	const changePlanHandler = (e) => {
		let name = e.target.name;

		if (name === 'presencial') setChangePlan(plans1);
		// if (name === 'en linea') setChangePlan(plans2);
	};

	let countdownTimestampMs = 'Tue, 05 May 2026 12:00:00 GMT-5';

	const defaultRemainingTime = {
		seconds: '00',
		minutes: '00',
		hours: '00',
		days: '00',
	};

	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	return (
		<section className={style.mainSection} id='plans'>
			<SimpleModal
				close={close}
				handlerClose={handlerClose}
				handleCloseModal={handleCloseModal}
				url={url}
				plan={plans1}
			/>
			<SimpleModal2
				close={close2}
				handlerClose={handlerClose2}
				handleCloseModal={handleCloseModal2}
			/>
			<div className={style.mainContainer}>
				<h1 className={style.title}>
					¡EMPIEZA AHORA!
					{/* <span>
						<b>&nbsp;</b>
					</span> */}
				</h1>

				{/* <p className={style.paragraph}>
					+200 entrenamientos <br /> por un precio que NUNCA volverá
				</p> */}

				{/* <div className={style.imagesContainer}>
					<img className={style.lineL} src={lineLeft} alt='lineLeft' />
					<img className={style.lineR} src={lineRight} alt='lineRight' />

					<h1>SALE 30% OFF</h1>
				</div> */}

				{/* <div className={style.cntCountdown}>
					<div className={style.membershipCountdown}>
						<h5 className={style.membershipCountdownTitle}>Inicio 5 de mayo</h5>
						<div className={style.membershipCountdownCounter}>
							<div className={style.membershipCountdownCounterItem}>
								<span>Días</span>
								<p>{remainingTime.days}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Horas</span>
								<p>{remainingTime.hours}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Minutos</span>
								<p>{remainingTime.minutes}</p>
							</div>
							<div className={style.membershipCountdownCounterItem}>
								<span>Segundos</span>
								<p>{remainingTime.seconds}</p>
							</div>
						</div>
					</div>
				</div> */}

				<div className={style.plansContainer}>
					{plans1.map((plan, i) => (
						<div
							className={`${style.cardContainer} ${plan.center ? style.cardCenter : null}`}
							key={i}
						>
							{plan.top ? (
								<img className={style.lines2} src={lineTop} alt='lineTop' />
							) : (
								<img className={style.lines} src={lineBot} alt='lineBot' />
							)}

							{plan.ball ? <div className={style.ball}></div> : null}

							{/* {plan.center ? (
								<div className={style.banda}>
									<h3> {plan?.promo} </h3>
								</div>
							) : null} */}
							<div style={{ marginBottom: '24px' }}>
								<h2> {plan?.title} </h2>
								<p> {plan?.descrition} </p>
							</div>
							<h1> {plan?.price} </h1>
							{plan?.priceBefore ? <h4> {plan?.priceBefore}</h4> : null}
							<a
								style={{ marginTop: '12px' }}
								onClick={() => handlerClose(plan?.urls.ninguno)}
								// href={plan?.urls.ninguno}
							>
								Comprar ahora
								{/* Pago Colombia */}
								<BsArrowRight />
							</a>

							<a
								style={{ marginTop: '12px', marginBottom: '12px' }}
								onClick={() => handlerClose2()}
								// href={plan?.urls.internacional}
							>
								Plan financiación <BsArrowRight />
							</a>
							<ul>
								{plan.items.map((item, i) => (
									<li key={i}>
										<div className={style.check}>
											<IoCheckmark />
										</div>
										{item.title}
										{item.more ? (
											<AiFillQuestionCircle
												className={style.questionCircle}
												onClick={() => {
													openModal(item.more);
												}}
											/>
										) : null}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				{/* <div className={style.videosContainer}>
					<ReactPlayer
						className='player2'
						url='https://youtube.com/shorts/z3KygkFnpzI?feature=share'
						playing={false}
						controls={true}
						volume={0}
						width='100%'
						height='100%'
						playsinline
					/>
					<ReactPlayer
						className='player2'
						url='https://youtube.com/shorts/KyxhA5P5HzI?feature=share'
						playing={false}
						controls={true}
						volume={0}
						width='100%'
						height='100%'
						playsinline
					/>
					<ReactPlayer
						className='player2'
						url='https://youtube.com/shorts/Yyp4zyEjkVU?feature=share'
						playing={false}
						controls={true}
						volume={0}
						width='100%'
						height='100%'
						playsinline
					/>
					<ReactPlayer
						className='player2'
						url='https://youtube.com/shorts/0R7WSz7lMI4?feature=share'
						playing={false}
						controls={true}
						volume={0}
						width='100%'
						height='100%'
						playsinline
					/>
				</div> */}
			</div>
			{/* <SupportInitiative modal={modal} closeModal={closeModal} more={more} /> */}
		</section>
	);
}

export default Plans;
